import {AdUnitBean} from 'common/api/api'
import {Form, InputNumber, Radio, Select} from 'antd'
import MimeTypesEnum = AdUnitBean.MimeTypesEnum

const FormItem = Form.Item

const Option = Select.Option
const RadioGroup = Radio.Group

interface Props {
  startDelay: any
  customMidRoll: any
  placement: any
  linearity: any
}

const AdUnitVideoFormat = (props: Props) => {
  const startDelays = [
    { name: 'Pre-roll', value: 0 },
    { name: 'Generic mid-roll', value: -1 },
    { name: 'Generic post-roll', value: -2 },
    { name: 'Custom mid-roll:', value: 1 },
  ]

  const placements = [
    { name: 'In-Stream', value: 1 },
    { name: 'In-Banner', value: 2 },
    { name: 'In-Article', value: 3 },
    { name: 'In-Feed', value: 4 },
    { name: 'Interstitial/Slider/Floating', value: 5 },
  ]

  const linearities = [
    { name: 'Linear / In-Stream', value: 1 },
    { name: 'Non-Linear / Overlay', value: 2 },
  ]

  const mimesTypes = (type: MimeTypesEnum) => {
    switch (type) {
      case MimeTypesEnum.Mpeg:
        return 'video/mpeg'
      case MimeTypesEnum.Mp4:
        return 'video/mp4'
      case MimeTypesEnum.Ogg:
        return 'video/ogg'
      case MimeTypesEnum.Quicktime:
        return 'video/quicktime'
      case MimeTypesEnum.Webm:
        return 'video/webm'
      case MimeTypesEnum.XMsWmv:
        return 'video/x-ms-wmv'
      case MimeTypesEnum.XFlv:
        return 'video/x-flv'
      case MimeTypesEnum._3gpp:
        return 'video/video/3gpp'
      case MimeTypesEnum._3gpp2:
        return 'video/video/3gpp2'
      default:
        return ''
    }
  }

  return (
    <div>
      <FormItem label="Start delay" required style={{ marginBottom: 0 }}>
        <FormItem
          name="startDelay"
          style={{ display: 'inline-block' }}
          required
          rules={[{ required: true, message: 'Please input Start delay' }]}
        >
          <RadioGroup>
            {Object.values(startDelays).map((mode) => (
              <Radio key={mode.name} value={mode.value}>
                {mode.name}
              </Radio>
            ))}
          </RadioGroup>
        </FormItem>
        <FormItem style={{ display: 'inline-block', marginBottom: 0 }}>
          <FormItem
            name="customMidRoll"
            rules={[{ required: props.startDelay === 1, message: 'Please input' }]}
            style={{ display: 'inline-block', margin: '0 8px' }}
          >
            <InputNumber
                value={props.customMidRoll}
              disabled={props.startDelay == undefined || props.startDelay <= 0}
              min={0}
            />
          </FormItem>
          <FormItem style={{ display: 'inline-block' }}>
            <span className="ant-form-text"> seconds</span>
          </FormItem>
        </FormItem>
      </FormItem>
      <FormItem name="placement" label="Placement" rules={[{ required: true, message: 'Please input Placement' }]}>
        <Select placeholder="Select placement" allowClear>
          {Object.values(placements).map((placement) => (
            <Option key={placement.name} value={placement.value}>
              {placement.name}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem name="linearity" label="Linearity" rules={[{ required: true, message: 'Please input Linearity' }]}>
        <Select placeholder="Select linearity" allowClear>
          {Object.values(linearities).map((lin) => (
            <Option key={lin.name} value={lin.value}>
              {lin.name}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem name="mimeTypes" label="Mime Types" rules={[{ required: true, message: 'Please input Mime Type' }]}>
        <Select placeholder="Select mime" mode="multiple" allowClear>
          {Object.values([
            MimeTypesEnum.Mpeg,
            MimeTypesEnum.Mp4,
            MimeTypesEnum.Ogg,
            MimeTypesEnum.Quicktime,
            MimeTypesEnum.Webm,
            MimeTypesEnum.XMsWmv,
            MimeTypesEnum.XFlv,
            MimeTypesEnum._3gpp,
            MimeTypesEnum._3gpp2,
          ]).map((type) => (
            <Option key={type} value={type}>
              {mimesTypes(type)}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem
        name="minDuration"
        rules={[{ required: true, message: 'Please input Min duration' }]}
        label="Min duration"
      >
        <InputNumber min={0} />
      </FormItem>
      <FormItem
        name="maxDuration"
        rules={[{ required: true, message: 'Please input Max duration' }]}
        label="Max duration"
      >
        <InputNumber min={0} />
      </FormItem>
    </div>
  )
}

export default AdUnitVideoFormat
